import {preserveProfenzHandoffQuery} from './fenzsafeProfenzHandoff';

export const FENZSAFE_RETURN_PATH = '/fenzsafe' as const;
type AuthDestination = '/' | typeof FENZSAFE_RETURN_PATH;

/**
 * Only the single product route approved for this entry flow may cross authentication.
 * `/fenzsafe/try` (the guest-first entry, Issue #192 Docket #19) is included alongside the
 * authenticated `/fenzsafe` route itself -- a guest converting to an account should land back on
 * FenzSafe, the same as a signed-out visitor who followed a direct `/fenzsafe` link.
 */
export function requestedAuthDestination(location: Pick<Location, 'pathname'|'search'> = window.location): AuthDestination {
  const values = new URLSearchParams(location.search).getAll('return_to');
  if (values.length === 1 && values[0] === FENZSAFE_RETURN_PATH) return FENZSAFE_RETURN_PATH;
  if (values.length === 0 && (location.pathname === FENZSAFE_RETURN_PATH || location.pathname === '/fenzsafe/try')) return FENZSAFE_RETURN_PATH;
  return '/';
}

export function authJourneyUrl(targetPath: '/sign-in'|'/sign-up'|'/mfa'): string {
  const destination = requestedAuthDestination();
  const params = new URLSearchParams();
  if (destination === FENZSAFE_RETURN_PATH) params.set('return_to', destination);
  const target = params.size === 0 ? targetPath : `${targetPath}?${params.toString()}`;
  return preserveProfenzHandoffQuery(target);
}

/** A one-use pending handoff is more specific than the ordinary product-entry destination. */
export function authCompletionUrl(): AuthDestination|string {
  const withHandoff = preserveProfenzHandoffQuery('/');
  return withHandoff === '/' ? requestedAuthDestination() : withHandoff;
}

export function signupReturnPath(): typeof FENZSAFE_RETURN_PATH|undefined {
  return requestedAuthDestination() === FENZSAFE_RETURN_PATH ? FENZSAFE_RETURN_PATH : undefined;
}
